<div class="importSemiAutoWrapper">
  <div class="importProgressBar">
    <p-progressBar [value]="semiAutoImportProgress()" id="semiautobar"></p-progressBar>
    <button mat-flat-button color="warn" class="semiautoImportStopButton"
      aria-label="Stop current semi-automatic import" (click)="onClicStopProcess()">
      <neq-icon svgIcon="close" style="padding-top: 5px;"></neq-icon>
    </button>
  </div>
  <div class="importFileName">
    <p class="filenameLabel">{{ componentLabel | translate }}
      <br />{{processedFilename}}
    </p>
  </div>
  <div>
    <p-splitButton id="splitButtonHeaderSemiAutoImport" [ngClass]="{ 'disable-next-button': isLastRm}"
      label="{{ 'label.user.rawmaterial.header.import.semi-auto.next' |translate }}" [model]="items"
      (onClick)="nextRm()"></p-splitButton>
  </div>
</div>
